// 👇 Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// 👇 Axios Imports
import axios from 'axios'

import {urlDispatchService, urlConfigCacheService, urlOceanBookingService} from '@src/endpoints'
import { getUriParams } from '@utils'

export const getData = createAsyncThunk('toDoTranportation/getData', async data => {
  const {params, filterForm} = data
  const uri = getUriParams({...params, status:"", q:""})
  const response = await axios.post(`${urlDispatchService}/GetToDoList?${uri}`, filterForm)
  return {
    params,
    terminal: [],
    data: response.data.data || [],
    totalPages: response.data.totalCount,
    loaded: true,
    filterForm
  }
})

export const getMissedLRDContainers = createAsyncThunk('toDoTranportation/getMissedLRDContainers', async data => {
  const {params, filterForm} = data
  const uri = getUriParams({...params, status:"", q:""})
  const response = await axios.post(`${urlOceanBookingService}/GetMissedLRDContainers?${uri}`, filterForm)
  return {
    params,
    data: response.data.data || [],
    totalPages: response.data.totalCount,
    loaded: true,
    filterForm
  }
})

//ocean booking service / GetHoldOrDoNotSplitBookingList - Count Only
export const getHoldOrDoNotSplitBookingListCount = createAsyncThunk('toDoTranportation/getHoldOrDoNotSplitBookingListCount', async data => {
  const {params, filterForm} = data
  const uri = getUriParams({...params, status:"", q:""})
  //remove todoType from filterForm
  const updatedFilterForm = {...filterForm}
  delete updatedFilterForm.todoType
  updatedFilterForm.latestReceivingDate = new Date().toISOString() //set latestReceivingDate to current date
  try {
    const response = await axios.post(`${urlOceanBookingService}/GetHoldOrDoNotSplitBookingList?${uri}`, updatedFilterForm)
    return {
      totalHoldandDoNotSplit: response.data.totalCount || 0
    }
  } catch (error) {
    return {
      totalHoldandDoNotSplit: 0
    }
  }
})

//ocean booking service / GetHoldOrDoNotSplitBookingList
export const getHoldOrDoNotSplitBookingList = createAsyncThunk('toDoTranportation/getHoldOrDoNotSplitBookingList', async data => {
  const {params, filterForm} = data
  const uri = getUriParams({...params, status:"", q:""})
  //remove todoType from filterForm
  const updatedFilterForm = {...filterForm}
  delete updatedFilterForm.todoType
  updatedFilterForm.latestReceivingDate = new Date().toISOString() //set latestReceivingDate to current date
  try {
    const response = await axios.post(`${urlOceanBookingService}/GetHoldOrDoNotSplitBookingList?${uri}`, updatedFilterForm)
    return {
      params,
      data: response.data.data || [],
      totalHoldandDoNotSplit: response.data.totalCount,
      loaded: true,
      filterForm // Keep original filterForm with todoType intact
    }
  } catch (error) {
    return {
      params,
      data: [],
      totalHoldandDoNotSplit: 0,
      loaded: true,
      filterForm // Keep original filterForm with todoType intact
    }
  }
})

export const getSSLines = async () => {
  const response = await axios.get(`${urlConfigCacheService}/SteamshipLine`)
  return response.data
}

export const toDoTranportationSlice = createSlice({
  name: 'toDoTranportation',
  initialState: {
    loaded : false,
    data: [],
    terminal: [],
    terminalTotal: 0,
    totalHoldandDoNotSplit: 0,
    total: 1,
    params: {},
    filterForm: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loaded = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loaded = true
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.terminal = action.payload.terminal
        state.filterForm = action.payload.filterForm
      })
      .addCase(getMissedLRDContainers.fulfilled, (state, action) => {
        state.loaded = true
        state.terminal = action.payload.data
        state.params = action.payload.params
        state.terminalTotal = action.payload.totalPages
        state.filterForm = action.payload.filterForm
      })
      .addCase(getHoldOrDoNotSplitBookingList.fulfilled, (state, action) => {
        state.loaded = true
        // state.data = action.payload.data
        state.data = {...state.data, holdOrDontSplitData: action.payload.data} //merge holdOrDontSplitData with existing data
        state.params = action.payload.params
        state.totalHoldandDoNotSplit = action.payload.totalHoldandDoNotSplit
        state.filterForm = action.payload.filterForm
      })
      .addCase(getHoldOrDoNotSplitBookingListCount.fulfilled, (state, action) => {
        // Only update the count, don't overwrite other data
        state.totalHoldandDoNotSplit = action.payload.totalHoldandDoNotSplit
      })
      .addMatcher(action => action.type.endsWith('/pending'), (state) => {
        state.loaded = false        
      })
      //reset loaded to true if rejected
      .addMatcher(action => action.type.endsWith('/rejected'), (state) => {
        state.loaded = true
        state.data = []
      })
  }
})

export default toDoTranportationSlice.reducer
